// extracted by mini-css-extract-plugin
export default {"noNumberSpinner":"OrderFinances_noNumberSpinner__IYn91"};